const regExp = /((\+7?|8|9)(\s|-)?((\(\d{1,4}\))?(\s|-)?(\d([\d-]){5,15}\d))|(\s*\d){10})([^\d\-\\@)]|$)/g

const filterRemovePhone = (text: string, isHard: boolean) => {
  let transformedText = text;

  [...text.matchAll(regExp)].forEach(match => {
    if (match.length < 2) {
      return
    }

    const phone = match[1].replace('.', '').trim()

    if (!phone || phone.match(/^\s*\d+\s*-\s*\d+\s*$/)) {
      return
    }

    transformedText = transformedText.replace(phone, '[...]')
  })

  if (isHard) {
    transformedText = transformedText.replace(/\d\d\s*-\s*\d\d\s*-\s*\d\d/, '')
    transformedText = transformedText.replace(/\d{3}\s*-\s*\d{3}/, '')
  }

  return transformedText
}

export default filterRemovePhone
